import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const idTypeService = {
  getAllIdTypes,
  addIdType,
  getIdType
};


function getAllIdTypes() {
  return apiCall("GET", apiUrls.idtypes.base);
}

function addIdType(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.idtypes.base, request);
}

function getIdType(id) {
  return apiCall("GET", `${apiUrls.idtypes.base}/${id}`);
}
